import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Row } from 'antd';

import { BERA_REVISION_TYPE, type BeraJobSummaryListItem } from '@/types/Bera';
import { CloseIcon, InfoCircleIcon } from '@/assets/icons/v2';
import { useStartBeraRevision } from '@/views/Bera/_hooks';
import { ModalStyled } from '@/views/Bera/_components/styles';
import { ACTIONS_GUTTER, CONFIRM_ICON_SIZE, MODAL_CLOSE_ICON_SIZE, MODAL_CONFIRM_WIDTH } from '@/views/Bera/constants';

import * as S from './styles';

interface ModalFullRevisionProps {
	open: boolean;
	report: Pick<BeraJobSummaryListItem, 'id'>;
	onCancel: () => void;
}

export function ModalFullRevision({ open, report, onCancel }: Readonly<ModalFullRevisionProps>): JSX.Element {
	const { startRevision, isLoading } = useStartBeraRevision({ report, onSuccess: onCancel });

	function handleConfirm(): void {
		startRevision(BERA_REVISION_TYPE.FULL);
	}

	return (
		<ModalStyled
			centered
			open={open}
			footer={null}
			keyboard={false}
			onCancel={onCancel}
			maskClosable={false}
			closable={!isLoading}
			width={MODAL_CONFIRM_WIDTH}
			closeIcon={<CloseIcon width={MODAL_CLOSE_ICON_SIZE} height={MODAL_CLOSE_ICON_SIZE} />}
		>
			<S.Content>
				<S.Icon>
					<InfoCircleIcon width={CONFIRM_ICON_SIZE} height={CONFIRM_ICON_SIZE} />
				</S.Icon>
				<S.Description>
					{I18n.get('Once a revision is created, the current version can no longer be edited')}
				</S.Description>
				<Row justify="center" gutter={[ACTIONS_GUTTER, 0]}>
					<Col>
						<S.CancelButton disabled={isLoading} onClick={onCancel}>
							{I18n.get('Cancel')}
						</S.CancelButton>
					</Col>
					<Col>
						<S.ConfirmButton type="primary" loading={isLoading} onClick={handleConfirm}>
							{I18n.get('Continue')}
						</S.ConfirmButton>
					</Col>
				</Row>
			</S.Content>
		</ModalStyled>
	);
}
